import type {
  JobEditRequirementsPageProps,
  JobEditRequirementsValues,
} from './JobEditRequirementsPage.component';

export const COMPETENCIA_PRESETS = ['Inglês', 'Espanhol', 'Excel'] as const;
export const DIFERENCIAL_PRESETS = ['Inglês', 'Espanhol', 'Excel'] as const;

export const emptyValues: JobEditRequirementsValues = {
  ageMin: '',
  ageMax: '',
  selectedCompetencias: [],
  selectedDiferenciais: [],
  selectedDiversity: [],
  disabilityDetails: null,
};

export const filledValues: JobEditRequirementsValues = {
  ageMin: '18',
  ageMax: '24',
  selectedCompetencias: [
    {
      id: 'preset-ingles',
      name: 'Inglês',
      level: 'avancado',
      label: 'Inglês - Avançado',
    },
  ],
  selectedDiferenciais: [
    {
      id: 'preset-espanhol',
      name: 'Espanhol',
      level: 'intermediario',
      label: 'Espanhol - Intermediário',
    },
    {
      id: 'custom-photoshop',
      name: 'Adobe Photoshop',
      level: 'basico',
      label: 'Adobe Photoshop - Básico',
    },
  ],
  selectedDiversity: ['mulheres', 'pessoas-com-deficiencia'],
  disabilityDetails: {
    selectedIds: ['auditiva', 'fisica'],
    otherText: '',
    label: 'Pessoas com deficiência - Auditiva e Física',
  },
};

const baseProps: Omit<JobEditRequirementsPageProps, 'values'> = {
  jobName: 'Desenvolvimento de softwares',
  errors: {},
  isSubmitting: false,
  canSubmit: true,
  competenciaPresets: COMPETENCIA_PRESETS,
  diferencialPresets: DIFERENCIAL_PRESETS,
  onAgeChange: () => undefined,
  onPresetClick: () => undefined,
  onCustomSkillClick: () => undefined,
  onSkillRemove: () => undefined,
  onDiversityToggle: () => undefined,
  onBack: () => undefined,
  onSubmit: () => undefined,
};

export const emptyProps: JobEditRequirementsPageProps = {
  ...baseProps,
  values: emptyValues,
};

export const filledProps: JobEditRequirementsPageProps = {
  ...baseProps,
  values: filledValues,
};
